exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".infoContainer_e6QxF {\n    padding: 0 80px;\n}\n\n.divition_1NInZ {\n    margin: 10px 0;\n    border-top: 5px solid #040404;\n}\n\n.infoContainer_e6QxF > div > p {\n    text-align: center;\n    font-weight: 800;\n    font-style: italic;\n}\n\n.infoContainer_e6QxF > h3 {\n    text-align: center;\n    font-weight: 800;\n}\n\n.checkBoxContent_aQn9S {\n    padding-left: 10px;\n}\n\n.creditContainer_20VJq {\n    padding-bottom: 15px;\n}\n.creditContainer_20VJq > h4 {\n    display: inline;\n    font-size: 17.5px;\n    font-weight: 800;\n}\n\n.creditContainer_20VJq > span,\n.continue_1J_1c {\n    font-style: italic;\n    font-size: 13px;\n}\n\n.gapSection9_2wjGa {\n    height: 150px;\n}\n", ""]);

// exports
exports.locals = {
	"infoContainer": "infoContainer_e6QxF",
	"divition": "divition_1NInZ",
	"checkBoxContent": "checkBoxContent_aQn9S",
	"creditContainer": "creditContainer_20VJq",
	"continue": "continue_1J_1c",
	"gapSection9": "gapSection9_2wjGa"
};